import I18n from 'i18n-js';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _flatten from 'lodash/flatten';
import _maxBy from 'lodash/maxBy';
import formatCurrency from '../common/utils/format-currency';
import calcPrice from '../common/utils/calc-price';

export const isInsuranceCompulsory = delivery =>
  _get(delivery, 'quote.insurance.isCompulsory');

export const getSelectedInsuranceOption = delivery => dropOff => {
  if (dropOff.insuranceOption) {
    return dropOff.insuranceOption;
  }
  if (isInsuranceCompulsory(delivery)) {
    return _find(
      _get(delivery, 'quote.insurance.options', []),
      option => option.isIncluded,
    );
  }
  return undefined;
};

export const getSelectedInsuranceOptions = delivery =>
  delivery.detail.dropOffs.map(getSelectedInsuranceOption(delivery));

export const getInsuranceOptionID = insuranceOption => {
  if (!insuranceOption) {
    return undefined;
  }
  return insuranceOption.id || 0;
};

export const getDeliveriesInsuranceOptions = deliveries => {
  const allSelectedInsuranceOptions = _flatten(
    deliveries.map(getSelectedInsuranceOptions),
  );
  const selectedInsuranceOption = allSelectedInsuranceOptions[0];
  const selectedInsuranceOptionID = getInsuranceOptionID(
    selectedInsuranceOption,
  );

  const optionsCount = {};
  let allSameOption = true;
  let totalSelected = 0;
  let totalNonIncludedSelected = 0;
  let totalPrice = 0;
  let currency = null;
  let dropOffIndexWithHighestInsuranceOption;

  // get highest selected option index to know where to show apply to all in single MSD case
  if (deliveries.length === 1 && allSelectedInsuranceOptions.length > 1) {
    const maxOption = _maxBy(allSelectedInsuranceOptions, 'optionPremium');
    dropOffIndexWithHighestInsuranceOption = allSelectedInsuranceOptions.indexOf(
      maxOption,
    );
  }

  allSelectedInsuranceOptions.forEach(insuranceOption => {
    if (getInsuranceOptionID(insuranceOption) !== selectedInsuranceOptionID) {
      allSameOption = false;
    }
    if (insuranceOption) {
      if (!currency && insuranceOption.currency) {
        currency = insuranceOption.currency;
      }
      if (!insuranceOption.isIncluded) {
        totalNonIncludedSelected += 1;
      }
      totalSelected += 1;
      totalPrice += insuranceOption.optionPremium || 0;
      optionsCount[insuranceOption.title] =
        _get(optionsCount, insuranceOption.title, 0) + 1;
    }
  });

  const totalDisplayPrice =
    totalSelected && currency
      ? totalPrice > 0
        ? formatCurrency({
            code: _get(currency, 'code'),
            amount: calcPrice(totalPrice, currency),
          })
        : I18n.t('v2.anytimeBooking.insurance.included')
      : undefined;

  return {
    allSameOption,
    totalSelected,
    totalNonIncludedSelected,
    totalDisplayPrice,
    optionsCount,
    selectedInsuranceOption: allSameOption
      ? selectedInsuranceOption
      : undefined,
    selectedInsuranceOptionID: allSameOption
      ? selectedInsuranceOptionID
      : undefined,
    dropOffIndexWithHighestInsuranceOption,
  };
};

export default {};
